import { useContext, useEffect } from "react"
import { PageLayout } from "./components/layout/PageLayout"
import { PullToRefresh } from "./components/PullToRefresh/PullToRefresh"
import { Home } from "./pages/Home"
import { ThemeContext } from "./contexts/theme"

import "./App.css"

function App() {
  const { themeName } = useContext(ThemeContext)

  useEffect(() => {
    document.documentElement.classList.remove("light", "dark")
    document.documentElement.classList.add(themeName)
  }, [themeName])

  return (
    <div id="top" className="app">
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <PullToRefresh>
        <PageLayout>
          <Home />
        </PageLayout>
      </PullToRefresh>
    </div>
  )
}

export default App
